import { useEffect, useState } from 'react'
import { AddSearchSearchFieldProps } from '../../types'
import styles from './styles.module.scss'

export function SearchField(props: AddSearchSearchFieldProps) {
  const [shouldClear, setShouldClear] = useState(false)

  useEffect(() => {
    if (props.uiInstance) {
      props.uiInstance.searchField({
        selectorToBind: '.custom-search',
        ...props
      })
    }
  }, [props])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (shouldClear) {
      props.uiInstance?.clear()
      props.uiInstance?.search(event.target.value)

      setShouldClear(false)
    }
  }

  const handleFocus = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.nativeEvent.type === 'focusin') {
      if (
        event.target.value &&
        window.location.href.includes('search_facets')
      ) {
        setShouldClear(true)
      }
    } else {
      setShouldClear(false)
    }
  }

  return (
    <>
      <form autoComplete="off" action="?" role="search">
        <div className="search-field-wrapper">
          <input
            className={`${styles.CustomSearchField} custom-search`}
            type="search"
            id={props.containerId}
            placeholder="Search..."
            autoComplete="off"
            autoCorrect="off"
            spellCheck="false"
            onChange={handleChange}
            onFocus={handleFocus}
          />
        </div>
      </form>
    </>
  )
}
